import { crm_api, get } from "./services.common";

export const getUpcomingPoolAPI = async () => {
  let url = `${crm_api}/getUpcomingPool`;
  return await get(url);
};
